import { render } from "./PeopCent.vue?vue&type=template&id=ba12c4ae&scoped=true"
import script from "./PeopCent.vue?vue&type=script&lang=js"
export * from "./PeopCent.vue?vue&type=script&lang=js"

import "./PeopCent.vue?vue&type=style&index=0&id=ba12c4ae&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba12c4ae"]])

export default __exports__